import { Link } from "react-router-dom";
import { BUSINESS, HOURS, NAV_LINKS, SERVICE_AREAS } from "../../mocks/siteData";

export default function Footer() {
  const areaCol1 = SERVICE_AREAS.slice(0, 8);
  const areaCol2 = SERVICE_AREAS.slice(8);

  return (
    <footer className="bg-[#111111] text-white/70">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Col 1: Brand */}
          <div className="lg:col-span-1">
            <Link to="/">
              <img
                src={BUSINESS.logoUrl}
                alt="The Lash Bar"
                className="h-10 w-auto object-contain brightness-0 invert mb-5"
                title="The Lash Bar — Lehi, Utah"
              />
            </Link>
            <p className="font-sans text-sm leading-relaxed text-white/50 mb-6">
              Utah's premier beauty destination for lash extensions, hair styling, and tanning
              in Lehi, UT.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={BUSINESS.facebookUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-gold hover:text-gold transition-all duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a
                href={BUSINESS.blogUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Blog"
                className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-gold hover:text-gold transition-all duration-200 cursor-pointer"
              >
                <i className="ri-article-line text-sm" />
              </a>
              <a
                href={BUSINESS.shopUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Shop"
                className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-gold hover:text-gold transition-all duration-200 cursor-pointer"
              >
                <i className="ri-shopping-bag-line text-sm" />
              </a>
            </div>
          </div>

          {/* Col 2: Contact & Hours */}
          <div>
            <h4 className="font-serif text-white text-lg font-light mb-5">
              <a href="#contact" className="hover:text-gold transition-colors">Contact</a>
            </h4>
            <ul className="space-y-3 text-sm font-sans">
              <li>
                <a
                  href={BUSINESS.phoneTel}
                  className="flex items-start gap-2 hover:text-gold transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line text-gold mt-0.5 flex-shrink-0" />
                  {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS.directionsUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-start gap-2 hover:text-gold transition-colors cursor-pointer"
                >
                  <i className="ri-map-pin-line text-gold mt-0.5 flex-shrink-0" />
                  <span>
                    {BUSINESS.address}<br />{BUSINESS.city}, {BUSINESS.state} {BUSINESS.zip}
                  </span>
                </a>
              </li>
            </ul>

            <h4 className="font-serif text-white text-lg font-light mt-8 mb-4">Hours</h4>
            <ul className="space-y-1.5 text-xs font-sans">
              {HOURS.map((h) => (
                <li key={h.day} className="flex justify-between gap-4">
                  <span className="text-white/40">{h.day}</span>
                  <span className="text-white/70">{h.hours}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Navigation */}
          <div>
            <h4 className="font-serif text-white text-lg font-light mb-5">Navigate</h4>
            <ul className="space-y-2.5 text-sm font-sans">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="hover:text-gold transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={BUSINESS.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors cursor-pointer"
                >
                  Book an Appointment
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS.shopUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="hover:text-gold transition-colors cursor-pointer"
                >
                  Shop Boutique
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS.reviewUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="hover:text-gold transition-colors cursor-pointer"
                >
                  Leave a Review
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Service Areas */}
          <div>
            <h4 className="font-serif text-white text-lg font-light mb-5">Service Areas</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs font-sans">
              {areaCol1.map((area) => (
                <span key={area} className="hover:text-gold transition-colors cursor-default">
                  {area}
                </span>
              ))}
              {areaCol2.map((area) => (
                <span key={area} className="hover:text-gold transition-colors cursor-default">
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="font-sans text-xs text-white/30">
            &copy; {new Date().getFullYear()} The Lash Bar — Lehi, UT. All rights reserved.
          </p>
          <div className="flex items-center gap-1 font-sans text-xs text-gold">
            <i className="ri-star-fill text-xs" />
            <span className="text-white/50">4.9 &nbsp;·&nbsp; 901 Google Reviews</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
